export default __webpack_public_path__ + "static/media/aboutImg.5871f5d3.jpg";